export default class NBASettingsEntity {
  constructor() {
    const settings = {};
    /**
     * Set User Insight Enable
     */
    this.setInsightEnable = (enable) => {
      settings.insightEnable = enable;
    };
    /**
     * Get User Insight Enable
     */
    this.isInsightEnable = () => {
      return settings.insightEnable;
    };
    /**
     * Set User Splash Enabled
     */
    this.setSplashEnabled = (splash) => {
      settings.splashEnabled = splash;
    };
    /**
     * Get User Splash Enabled
     */
    this.isSplashEnabled = () => {
      return settings.splashEnabled;
    };
    /**
     * Set User Splash Id
     */
    this.setSplashId = (id) => {
      settings.splashId = id;
    };
    /**
     * Get User Splash Id
     */
    this.getSplashId = () => {
      return settings.splashId;
    };
    /**
     * Set User Splash Acknowledged
     */
    this.setSplashAcknowledged = (splash) => {
      // once we acknowledge the splash, persist it.
      if (window.sessionStorage && splash) {
        sessionStorage.setItem(settings.splashId, splash); // Acknowledge we've seen this splash
      }
      settings.splashAcknowledged = splash;
    };
    /**
     * Get User Splash Acknowledged
     */
    this.isSplashAcknowledged = () => {
      // if settings if false, but a local storage exists, return true
      if (window.sessionStorage) {
        const sessionSplashAcknowledged = sessionStorage.getItem(
          settings.splashId
        );
        return sessionSplashAcknowledged || settings.splashAcknowledged;
      }
      return settings.splashAcknowledged;
    };
  }
}
